// import CryptoJS from "crypto-js";

// const SECRET_KEY = "1234567890123456"; // fixed AES key (you can load from .env)

// // Utility to generate random IV
// const generateRandomIV = () => {
//   return CryptoJS.lib.WordArray.random(16);
// };

// export const encryptPayload = (data) => {
//   const json = JSON.stringify(data);

//   // Generate random IV each time
//   const iv = generateRandomIV();

//   const encrypted = CryptoJS.AES.encrypt(
//     json,
//     CryptoJS.enc.Utf8.parse(SECRET_KEY),
//     {
//       iv: iv,
//       mode: CryptoJS.mode.CBC,
//       padding: CryptoJS.pad.Pkcs7,
//     }
//   );

//   const hexCipher = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
//   const hexIV = iv.toString(CryptoJS.enc.Hex);

//   const payload = hexIV + hexCipher;

//   return payload;
// };

// import CryptoJS from "crypto-js";

// const SECRET_KEY = "1234567890123456";

// export function encryptPayload(plainText) {
//   if (typeof plainText !== "string") {
//     throw new Error("encryptPassword expects a string");
//   }

//   const key = CryptoJS.enc.Utf8.parse(SECRET_KEY); // 16 bytes
//   const iv = CryptoJS.lib.WordArray.random(16); // 16-byte IV

//   const encrypted = CryptoJS.AES.encrypt(
//     CryptoJS.enc.Utf8.parse(plainText), // raw string (NOT JSON)
//     key,
//     { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
//   );

//   const ivHex = CryptoJS.enc.Hex.stringify(iv);
//   const ctHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex); // careful: NOT Base64
//   return ivHex + ctHex;
// }

// function hexToBytes(hex) {
//   if (typeof hex !== "string" || hex.length % 2 !== 0) {
//     throw new Error("Invalid hex string");
//   }

//   const len = hex.length;
//   const bytes = new Uint8Array(len / 2);

//   for (let i = 0; i < len; i += 2) {
//     bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
//   }

//   return bytes;
// }

// // Utility: ArrayBuffer -> UTF-8 string
// function bufToString(buf) {
//   return new TextDecoder().decode(buf);
// }

// // Same key as Java STATIC_KEY_HEX (32 bytes = AES-256)
// const STATIC_KEY_HEX = "c973c89e4b0460f12d5a2fb0ab24930860acaac4c89ee7b7c5b2263b58ea9b04";

// // Convert static key from hex → CryptoKey
// async function getCryptoKey() {
//   const keyBytes = hexToBytes(STATIC_KEY_HEX);

//   return crypto.subtle.importKey("raw", keyBytes, { name: "AES-GCM" }, false, ["decrypt"]);
// }

// /**
//  * Decrypt the token generated by Java encryptToTokenNew().
//  */
// export async function decryptToken(tokenHex) {
//   try {
//     const tokenBytes = hexToBytes(tokenHex);

//     if (tokenBytes.length <= 12) {
//       throw new Error("Token too short");
//     }

//     // IV = first 12 bytes (96-bit nonce)
//     const iv = tokenBytes.slice(0, 12);

//     // Ciphertext + Tag = remainder
//     const ct = tokenBytes.slice(12);

//     const key = await getCryptoKey();

//     const decrypted = await crypto.subtle.decrypt(
//       {
//         name: "AES-GCM",
//         iv,
//         tagLength: 128,
//       },
//       key,
//       ct
//     );

//     return bufToString(decrypted);
//   } catch (err) {
//     console.error("Failed to decrypt token:", err);
//     return null;
//   }
// }

// /**
//  * Parse decrypted plaintext into structured fields
//  */
// export function parseDecryptedValue(plain) {
//   const parts = plain.split(":");

//   return {
//     username: parts[0],
//     password: parts[1],
//     timestamp: Number(parts[2]),
//     isTwoFactorAuthenticationRequired: parts[3].split("=")[1] === "true",
//     shouldRenewPassword: parts[4].split("=")[1] === "true",
//   };
// }

import CryptoJS from "crypto-js";

// Must match the Java SECRET_KEY exactly
const SECRET_KEY = "1234567890123456"; // 16 bytes = AES-128

/**
 * Encrypt plaintext to hex token compatible with Java.
 * tokenHex = hex(IV) + hex(ciphertext)
 * @param {string|object} plainText - String to encrypt or object to stringify and encrypt
 * @returns {string} Encrypted hex token
 */
export function encryptPayload(plainText) {
  let textToEncrypt;

  // Handle objects by converting to JSON string
  if (typeof plainText === "object" && plainText !== null) {
    try {
      textToEncrypt = JSON.stringify(plainText);
    } catch (error) {
      throw new Error("encryptPayload: Failed to stringify object - " + error.message);
    }
  } else if (typeof plainText === "string") {
    textToEncrypt = plainText;
  } else {
    throw new Error("encryptPayload expects a string or object");
  }

  const key = CryptoJS.enc.Utf8.parse(SECRET_KEY); // 16 bytes
  const iv = CryptoJS.lib.WordArray.random(16); // 16-byte IV

  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(textToEncrypt), key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const ivHex = CryptoJS.enc.Hex.stringify(iv);
  const ctHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex); // NOT Base64

  return ivHex + ctHex;
}

/**
 * Decrypts tokenHex produced either by encryptPayload (JS) or Java.
 * tokenHex = hex(IV) + hex(ciphertext)
 */
export function decryptPayload(tokenHex) {
  if (typeof tokenHex !== "string" || tokenHex.length < 32) {
    throw new Error("Invalid token hex");
  }

  const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);

  // First 16 bytes (32 hex chars) = IV
  const ivHex = tokenHex.slice(0, 32);
  const ctHex = tokenHex.slice(32);

  const iv = CryptoJS.enc.Hex.parse(ivHex);
  const ciphertext = CryptoJS.enc.Hex.parse(ctHex);

  const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext });

  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const plain = decrypted.toString(CryptoJS.enc.Utf8);
  if (!plain) {
    throw new Error("Failed to decrypt or bad padding");
  }
  console.log(plain, "plain");

  return plain;
}

/**
 * Parse decrypted plaintext into structured fields.
 * Expected format:
 *   username:password:timestamp:isTwoFactorAuthenticationRequired=true:shouldRenewPassword=false
 */
export function parseDecryptedValue(plain) {
  const parts = plain.split(":");

  return {
    username: parts[0],
    password: parts[1],
    timestamp: Number(parts[2]),
    isTwoFactorAuthenticationRequired: parts[3].split("=")[1] === "true",
    shouldRenewPassword: parts[4].split("=")[1] === "true",
  };
}

/**
 * Helper: build the login token string in your standard format,
 * then encrypt it with encryptPayload.
 */
export function buildAndEncryptLoginToken(
  username,
  password,
  isTwoFactorAuthenticationRequired,
  shouldRenewPassword
) {
  const plain = `${username}:${password}: +
    ${Date.now()}: +
    isTwoFactorAuthenticationRequired=${isTwoFactorAuthenticationRequired}: +
    shouldRenewPassword=${shouldRenewPassword}`;

  return encryptPayload(plain);
}

/**
 * Helper: decrypt a login token and parse it to a structured object.
 */
export function decryptLoginToken(tokenHex) {
  const plain = decryptPayload(tokenHex);
  return parseDecryptedValue(plain);
}
